import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=0814d94c&scoped=true"
import script from "./DefaultTemplate.vue?vue&type=script&lang=ts"
export * from "./DefaultTemplate.vue?vue&type=script&lang=ts"
import style0 from "./DefaultTemplate.vue?vue&type=style&index=0&id=0814d94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0814d94c",
  null
  
)

export default component.exports